import Dialog from 'global/guides/Dialog'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'
import { PlanoFixo, planos } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirPlano() {
    const navigate = useNavigate()
    const { planoId } = useParams()
    const handleBack = () => navigate('/administracao/planos-precos')

    const { data } = useOutletContext<{ data?: PlanoFixo[] }>()
    const plano = data?.find(item => item.id === Number(planoId))

    const { mutate, isLoading } = planos.mutations.useDelete({
        invalidateQuery: true,
    })

    function handleSubmit() {
        mutate(plano!.id, {
            onSuccess: () => {
                toast.success('Plano removido com sucesso!')
                handleBack()
            },
            onError: () => {
                toast.error('Erro ao remover plano')
            },
        })
    }

    if (!plano) return null

    return (
        <Dialog.Root
            onClose={handleBack}
            onSubmit={handleSubmit}
            width="26rem"
            height="auto"
            loading={isLoading}
        >
            <Dialog.Title>Excluir plano</Dialog.Title>
            <Dialog.Content dividers>
                Você tem certeza que deseja excluir este plano?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
